import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVernieuwenRegenpijpen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      d="M29.39 34.29a6.6 6.6 0 0 0-2.12-.7 6.6 6.6 0 0 0 .73 2.12 1 1 0 0 0 1.41 0 1 1 0 0 0-.02-1.42"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M27.3 31.51a1 1 0 0 1-.3-.72V15h1v-2h-5v2h1v17a1 1 0 0 0 .3.72l2.49 2.49 2.12-2.13z"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      d="M27 8.5c0-1.1-2-4-2-4s-2 2.9-2 4a2 2 0 1 0 4 0M29 11a6.6 6.6 0 0 0-1-2 6.6 6.6 0 0 0-1 2 1 1 0 0 0 2 0"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M9.71 3.98 21.96 11v25.06H5.03"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M25.25 17.63h-5v-1h5zM25.25 30h-5v-1h5z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVernieuwenRegenpijpen);

export default ForwardRef;
